<template>
  <div class="newPerfect">

    <Form
      :model="form"
      :rules="rules"
      v-model="regular"
    >
      <component
        v-for="(app, index) in cacheComps"
        :is="app.component"
        :label="app.label"
        :placeholder="app.placeholder"
        :max="app.max"
        :min="app.min"
        :reg="app.reg"
        v-model="form[app.model]"
        :columnsTerm="app.columnsTerm"
        :key="index"
        :readonly="app.readonly"
        :maxlength="app.maxlength"
        :labelWidth="app.labelWidth"
        :class="app.class"
        :amountCompany="app.amountCompany"
        :toUpperCase="app.toUpperCase"
      />
    </Form>
    <div
      class="Contract"
      v-if="contractList.length > 0"
    >
      <Contract
        :list="contractList"
        v-model="form.isAgree"
      />
    </div>
    <div v-if="cacheComps.length > 0">
      <Button
        :loading="commonForms.Isloading"
        loadingText="提交中..."
        type="danger"
        text="提交"
        :disabled="!regular"
        class="nextStep"
        :click="nextStep"
      />
    </div>
  </div>
</template>

<script>
import Form from '@/components/Form.vue';
// eslint-disable-next-line import/no-duplicates
import Input from '@/components/Input.vue';
// eslint-disable-next-line import/no-duplicates
import RangeInput from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import Contract from '@/components/Contract.vue';
import JSencrypt from '@/utils/rsa/jsencrypt';
import AmountUnitInput from '@/components/AmountUnitInput.vue';
import PeopleUnitInput from '@/components/PeopleUnitInput.vue';
import PhoneInput from '@/components/PhoneInput.vue';
import NameInput from '@/components/NameInput.vue';
import MessageCode from './MessageCode.vue';
import loanAmountInput from './loanAmountInput.vue';
import Select from './Select.vue';
import RelatedSelect from './RelatedSelect.vue';
import LocatedPlacePicker from './LocatedPlacePicker.vue';
import LivingPlacePicker from './LivingPlacePicker.vue';
import CompanySelect from './CompanySelect.vue';


import {
  createdRangeInput,
  createdBWSelect,
  createdLocatedPlacePicker,
  createdMessageCode,
  createdCompanySelect,
  createdLivingPlacePicker,
  createdloanAmountInput,
  createOperatingIncomeInput,
  createPeopleUnitInput,
  createPhoneInput,
} from '../creatComponents';

export default {
  name: 'newPerfect',
  components: {
    Form,
    Input,
    Button,
    Contract,
    RangeInput,
    RelatedSelect,
    CompanySelect,
    loanAmountInput,
    AmountUnitInput,
    PeopleUnitInput,
    PhoneInput,
    NameInput,
  },
  props: ['elementData', 'support', 'referrerPre', 'oldOrderId'],
  data() {
    return {
      form: {
        corpName: '', // 企业名称
        taxNo: '', // 企业税号
        userType: '', // 申请人类型
        borrowerName: '', // 姓名
        borrowerIdentity: '', // 身份证号
        borrowerPhone: '', // 手机号码
        captcha: '', // 短信验证
        loanAmount: '', // 借款金额
        termLoan: '', // 借款期限
        loanIntendedUse: '', // 借款用途
        referrer: '', // 邀请码
        LocatedPlacePicker: '', // 经营地址
        marriage: '', // 婚姻状况
        relationshipWith: '',
        marriageRelationshipWith: '',
        bizAddress: '',
        bizAddressCode: '',
        borrowerType: '',
        borrowerAddress: '',
        livingBorrowerAddress: '',
        borrowerAddressCode: '',
        bankCard: '', // 银行卡号
        iceContactName: '', // 紧急联系人姓名
        iceContactIdentity: '', // 紧急联系人身份证号
        iceContactPhone: '', // 紧急联系人电话
        creditBankCard: '', // 信用卡号
        borrowerEmail: '',
        borrowerLiveType: '',
        education: '',
        corpId: '',
        creditAccount: '',
        relationMobilePhone: '',
        relationName: '',
        operatingIncome: '', // 营业收入
        practitioners: '', // 从业人员
        totalAssets: '', // 资产总额
        financeStaffName: '', // 财务联系人姓名
        financeStaffPhone: '', // 财务联系人电话
        isAgree: true,
      },
      rules: {},
      regular: false,
      loading: false,
      cacheComps: [],
      contractList: [],
      orderId: '',
      userId: '',
    };
  },
  watch: {
    elementData: {
      handler(val) {
        const regExp = {};
        val.forEach((e) => {
          if (e.key === 'bizProvince/bizCity/bizCounty/bizAddressCode') {
            regExp.LocatedPlacePicker = [
              {
                required: true,
              },
            ];
          } else if (
            e.key === 'borrowerProvince/borrowerCity/borrowerCounty/borrowerAddressCode'
          ) {
            regExp.livingBorrowerAddress = [
              {
                required: true,
              },
            ];
          } else {
            regExp[e.key] = [
              {
                required: true,
                pattern: (e.pattern || '')[0] || '',
              },
            ];
          }
        });
        this.rules = regExp;
        this.ergodicData(val);
      },
      deep: true,
      immediate: true,
    },
    referrerPre: {
      handler(val) {
        this.form = {
          ...this.form,
          referrer: val,
        };
      },
      deep: true,
    },
    form: {
      handler(val) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in val) {
          if (Object.hasOwnProperty.call(val, key)) {
            const element = val[key];
            if (element && this.publicPage.form[key] !== element) {
              this.updateFormState({
                [key]: element,
              });
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  provide() {
    return {
      root: this,
    };
  },

  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
  },
  mounted() {
    this.form = {
      ...this.form,
      ...this.publicPage.form,
    };
    this.getUserCorp();
  },
  methods: {
    ...mapMutations('publicPage', ['updateState', 'updateFormState']),
    ...mapActions('commonForms', ['getModel']),
    ...mapMutations('commonForms', ['updateForm']),
    getSelect(val) {
      this.form = {
        ...this.form,
        taxNo: val.taxNo,
        userType: val.userType,
        corpId: val.corpId,
        corpName: val.corpName,
        borrowerType: val.userTypeDesc,
      };
    },
    getBizAddressCode(val) {
      this.form.bizAddressCode = val;
    },
    getBorrowerAddressCode(val) {
      this.form.borrowerAddressCode = val;
    },
    getMarriage(val) {
      this.form = {
        ...this.form,
        marriage: { ...val },
      };
    },
    getRelationshipWith(val) {
      this.form = {
        ...this.form,
        relationshipWith: { ...val },
      };
    },
    ergodicData(data) {
      data.forEach((e) => {
        // eslint-disable-next-line default-case
        switch (e.type) {
          case 'RangeInput':
            createdRangeInput.call(this, e, RangeInput);
            break;
          case 'BWSelect':
            createdBWSelect.call(this, e, Select);
            break;
          case 'Input':
            createdRangeInput.call(this, e, RangeInput);
            break;
          case 'LocatedPlacePicker':
            createdLocatedPlacePicker.call(this, e, LocatedPlacePicker);
            break;
          case 'LivingPlacePicker':
            createdLivingPlacePicker.call(this, e, LivingPlacePicker);
            break;
          case 'MessageCode':
            createdMessageCode.call(this, e, MessageCode);
            break;
          case 'contract':
            localStorage.setItem('contractMap', JSON.stringify(e.values));
            this.contractList = e.values;
            break;
          case 'CompanySelect':
            createdCompanySelect.call(this, e, CompanySelect);
            break;
          case 'loanAmountInput':
            createdloanAmountInput.call(this, e, loanAmountInput);
            break;
          case 'AmountUnitInput':
            createOperatingIncomeInput.call(this, e, AmountUnitInput);
            break;
          case 'PeopleUnitInput':
            createPeopleUnitInput.call(this, e, PeopleUnitInput);
            break;
          case 'PhoneInput':
            createPhoneInput.call(this, e, PhoneInput);
            break;
          case 'NameInput':
            createPhoneInput.call(this, e, NameInput);
            break;
        }
      });
    },
    async nextStep() {
      const data = JSON.parse(JSON.stringify(this.form));
      const address = data.LocatedPlacePicker.split(' ');
      const borrowerAddress = data.livingBorrowerAddress.split(' ');
      const encrypt = new JSencrypt();
      const res = await this.$api.PublicPage.getNewProductId({
        productId: this.$route.query.productId,
        taxNo: this.form.taxNo,
      });
      encrypt.setPublicKey(
        'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ==',
      );
      const obj = {
        orderId: this.orderId,
        productId: res.data,
        bizProvince: address[0],
        bizCity: address[1],
        bizCounty: address[2],
        borrowerProvince: borrowerAddress[0],
        borrowerCity: borrowerAddress[1],
        borrowerCounty: borrowerAddress[2],
        bankCard: encrypt.encrypt(this.form.bankCard) || '',
        creditBankCard: encrypt.encrypt(this.form.creditBankCard) || '',
        iceContactIdentity: encrypt.encrypt(this.form.iceContactIdentity) || '',
        iceContactPhone: encrypt.encrypt(this.form.iceContactPhone) || '',

        loanAmount: this.form.loanAmount, // 借款金额
        termLoan: this.form.termLoan,
        loanIntendedUse: this.form.loanIntendedUse,
        referrer: this.form.referrer,
        corpId: this.form.corpId || '',
        corpName: this.form.corpName,
        taxNo: this.form.taxNo,
        bizAddress: this.form.bizAddress,
        bizAddressCode: this.form.bizAddressCode,
        userType: this.form.userType,
        borrowerEmail: this.form.borrowerEmail,
        borrowerLiveType: this.form.borrowerLiveType,
        borrowerAddress: this.form.borrowerAddress,
        borrowerAddressCode: this.form.borrowerAddressCode,
        education: this.form.education,
        marriage: this.form.marriage,
        relationshipWith: this.form.relationshipWith,
        iceContactName: this.form.iceContactName,
        captcha: this.form.captcha,
        relationMobilePhone: this.form.relationMobilePhone,
        relationName: this.form.relationName,
        operatingIncome: this.form.operatingIncome,
        practitioners: this.form.practitioners,
        totalAssets: this.form.totalAssets,
        financeStaffName: this.form.financeStaffName,
        financeStaffPhone: this.form.financeStaffPhone,
        foreignOrderId: this.$route.query.foreignOrderId,
      };
      this.setData(obj);
    },
    setData(data) {
      this.updateForm({
        Isloading: true,
      });
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      const result = data;
      if (this.elementData.slice(-1)[0].key === 'contract') {
        result.typeList = this.elementData.slice(-1)[0].values.map((e) => e.value);
      }
      this.$api.PublicPage.saveOrder(data).then((res) => {
        this.loading = false;
        this.$toast.clear();
        if (res.success) {
          localStorage.setItem('orderId', res.data.orderId);
          this.updateForm({
            orderId: res.data.orderId,
          });
          this.orderId = res.data.orderId;
          this.getModel();
        } else {
          this.updateForm({
            Isloading: false,
          });
          this.$toast.fail({
            message: res.returnMessage,
            forbidClick: true,
          });
        }
      });
    },
    getUserCorp() {
      this.$api.PublicPage.getUserCorp({
        productId: this.$route.query.productId,
        foreignOrderId: this.$route.query.foreignOrderId,
      }).then((res) => {
        if (res.success) {
          const {
            identity,
            phone,
            userId,
            userType,
            userName,
            corpId,
            corpName,
            taxNo,
            userTypeDesc,
          } = res.data;
          this.form = {
            ...this.form,
            borrowerIdentity: identity,
            borrowerName: userName,
            borrowerPhone: phone,
            userType: userTypeDesc,
            borrowerType: userTypeDesc,
            corpName, // 企业名称
            taxNo,
          };
          this.form.corpId = corpId;
          this.form.userType = userType;
          this.userId = userId;
          this.updateState({
            borrowerPhone: phone,
          });
        }
        this.getPerfectOrderInfo();
      });
    },
    // 获取信息回显
    getPerfectOrderInfo() {
      this.$api.PublicPage.getPerfectOrderInfo(this.$route.query.productId).then((res) => {
        if (!res.success) return;
        const {
          loanAmount = '',
          corpName = '',
          bankCard = '',
          bizAddressCode = '',
          bizProvince = '',
          bizCity = '',
          bizCounty = '',
          bizPhone = '',
          bizAddress = '',
          borrowerAddress = '',
          borrowerAddressCode = '',
          borrowerProvince = '',
          borrowerCity = '',
          borrowerCounty = '',
          borrowerEmail = '',
          borrowerIdentity = '',
          borrowerLiveType = '',
          borrowerName = '',
          borrowerPhone = '',
          borrowerType = '',
          corpId = '',
          creditBankCard = '',
          creditCaptcha = '',
          creditPassword = '',
          education = '',
          iceContactIdentity = '',
          iceContactName = '',
          iceContactPhone = '',
          creditAccount = '',
          loanIntendedUse = '',
          marriage = '',
          relationshipWith = '',
          taxNo = '',
          termLoan = '',
          userId = '',
          orderId = '',
          relationMobilePhone = '',
          relationName = '',
          operatingIncome = '', // 营业收入
          practitioners = '', // 从业人员
          totalAssets = '', // 资产总额
          financeStaffName = '', // 财务联系人姓名
          financeStaffPhone = '', // 财务联系人电话
        } = res.data;
        this.form = {
          ...this.form,
          corpName,
          loanAmount,
          bankCard,
          bizAddressCode,
          bizPhone,
          bizAddress,
          borrowerAddress,
          borrowerAddressCode,
          borrowerEmail,
          borrowerIdentity,
          borrowerLiveType: borrowerLiveType !== null ? `${borrowerLiveType}` : '', //
          borrowerName,
          borrowerPhone,
          userType: borrowerType,
          borrowerType: borrowerType === 1 ? '法人' : '股东',
          corpId,
          creditAccount,
          creditBankCard,
          creditCaptcha,
          creditPassword,
          education: education !== null ? `${education}` : '',
          iceContactIdentity,
          iceContactName,
          iceContactPhone,
          loanIntendedUse: loanIntendedUse !== null ? `${loanIntendedUse}` : '',
          marriage: marriage !== null ? `${marriage}` : '',
          relationshipWith: relationshipWith !== null ? `${relationshipWith}` : '',
          taxNo,
          termLoan: termLoan !== null ? `${termLoan}` : '',
          livingBorrowerAddress: borrowerProvince
            ? `${borrowerProvince} ${borrowerCity} ${borrowerCounty}`
            : '',
          LocatedPlacePicker: bizProvince ? `${bizProvince} ${bizCity} ${bizCounty}` : '',
          relationMobilePhone,
          relationName,
          operatingIncome, // 营业收入
          practitioners, // 从业人员
          totalAssets, // 资产总额
          financeStaffName, // 财务联系人姓名
          financeStaffPhone, // 财务联系人电话
        };
        this.userId = userId;
        this.orderId = orderId;
      });
    },
  },
};
</script>
<style scoped>
.nextStep {
  margin: 32px 0;
}
.marginTop {
  margin-top: 8px;
}
.term::after,
.marginTop::after {
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.newPerfect >>> .van-field__label {
  margin-right: 0px !important;
}
.newPerfect >>> .van-field__label {
  width: 80px !important;
  color: #1c2438;
}
.newPerfect >>> .van-cell::after {
  border-bottom: 0px;
}
.newPerfect >>> input::-webkit-input-placeholder {
  color: #969799;
}
.newPerfect >>> input::-moz-input-placeholder {
  color: #969799;
}
.newPerfect >>> input::-ms-input-placeholder {
  color: #969799;
}
</style>
